import { Component, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IPhoneCallTag } from 'voxloud-types/dist/models';

@Component({
  selector: 'company-call-history-general-settings',
  templateUrl: './company-call-history-general-settings.component.html',
  styleUrls: ['./company-call-history-general-settings.component.scss']
})
export class CompanyCallHistoryGeneralSettingsComponent {

  public refreshTags: EventEmitter<void> = new EventEmitter();
  public allTags: IPhoneCallTag[] = [];

  constructor(
    private modalRef: NgbActiveModal
  ){}

  public close() {
    this.modalRef.close();
  }

  public onRefreshTags() {
    this.refreshTags.emit();
  }
}
